import { useTranslation } from 'react-i18next';
import { NameOfFrequency, NameOfFrequencyOriginal } from 'vopay';

export function useI18nLabels() {
  const { t } = useTranslation('translations');
  const mapFrequency: Record<NameOfFrequency | NameOfFrequencyOriginal, string> = {
    monthly: t('Global.FrequencyOptions.monthly'),
    weekly: t('Global.FrequencyOptions.weekly'),
    biweekly: t('Global.FrequencyOptions.biweekly'),
    '3 months': t('Global.FrequencyOptions.quarterly'),
    '6 months': t('Global.FrequencyOptions.semiAnnually'),
    yearly: t('Global.FrequencyOptions.annually'),
    bimonthly: t('Global.FrequencyOptions.bimonthly'),
    'semi-monthly': t('Global.FrequencyOptions.semiMonthly'),
    daily: t('Global.FrequencyOptions.daily'),
    single: t('Global.FrequencyOptions.single'),
    'bi-weekly': t('Global.FrequencyOptions.biweekly'),
    quarterly: t('Global.FrequencyOptions.quarterly'),
    'semi-annually': t('Global.FrequencyOptions.semiAnnually'),
    annually: t('Global.FrequencyOptions.annually'),
    weekdays: t('Global.FrequencyOptions.weekdays'),
    custom: t('Global.FrequencyOptions.custom'),
  };
  const frequencyLabelMapper = (value?: NameOfFrequency | NameOfFrequencyOriginal | ''): string => {
    if (!value) {
      return '';
    }
    return t(mapFrequency[value] || '');
  };
  const mapTransferType: Record<string, string> = {
    'fund-transfer': t('Global.TransferTypeOptions.fundTransfer'),
    'transfer-withdraw': t('Global.TransferTypeOptions.transferWithdraw'),
    'fund-transfer-withdraw': t('Global.TransferTypeOptions.fundTransferWithdraw'),
  };
  const transferTypeLabelMapper = (value: string, defaultLabel?: string): string => {
    return t(mapTransferType[value] ?? defaultLabel ?? t('Global.TransferTypeOptions.fundTransferWithdraw'));
  };
  const mapSemiMonthly: Record<string, string> = {
    SemiMonthFirstAndFifteenth: t('Global.SemiMonthlyDateOptions.firstAndFifteenth'),
    SemiMonthFifteenthAndLast: t('Global.SemiMonthlyDateOptions.fifteenthAndLast'),
  };
  const semiMonthlyDateLabelMapper = (value: string): string => {
    return t(mapSemiMonthly[value] || '');
  };

  return {
    frequencyLabelMapper,
    transferTypeLabelMapper,
    semiMonthlyDateLabelMapper,
  };
}
